webpackJsonp([236],{

/***/ 1310:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserWorkInfoTable_vue__ = __webpack_require__(3079);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d435890c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserWorkInfoTable_vue__ = __webpack_require__(5766);
function injectStyle (ssrContext) {
  __webpack_require__(5763)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d435890c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserWorkInfoTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d435890c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserWorkInfoTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * ElementUI 日期选择组件的参数
 * @Author: anker.wang
 * @Date: 2018-01-08 11:27:07
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-01-08 11:28:27
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dateTimePickerOptions: {
        shortcuts: [{
          text: '一周后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '明天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '今天',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      dateTimePickerRangeOptions: {
        shortcuts: [{
          text: '最近1周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近6个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近2年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 730);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1095);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  }
});

/***/ }),

/***/ 1348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = trimParams;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeEmptyParams;
/* unused harmony export setParams */
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* unused harmony export conveSomeDataType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSearchParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query, to.params);
        // 设置搜索参数。 当仅 params 更新时, 需要全部重置 search 数据
        vm.setSearchParams(_.merge(vm.$options.data.call(vm).search, queryParams));
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query, to.params);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     * @param {*} params
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$route.params;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      if (params.hasOwnProperty('')) {
        delete params[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, query, params), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSearchParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSearchParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      if (params[key] && params[key].constructor === Object) {
        setParams(params[key], newParams[key]);
      } else {
        Vue.set(params, key, newParams[key]);
      }
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 3079:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_workinfo_rules_js__ = __webpack_require__(5765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_mixins_dateTimePicker__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_mixins_table_v3__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_mixins_table__ = __webpack_require__(1346);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__core_mixins_table_v3__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__core_mixins_dateTimePicker__["a" /* default */]],
  data: function data() {
    return {
      searchRules: __WEBPACK_IMPORTED_MODULE_3__user_workinfo_rules_js__["a" /* searchRules */],
      search: {
        id: null,
        userid: null,
        cellphone: null,
        status: null,
        updated_at: []
      },
      searchFieldType: {
        current_page: Number,
        per_page: Number
      }
    };
  },

  computed: Vuex.mapState({
    workInfoStatus: function workInfoStatus(state) {
      return state.userWorkInfo.workInfoStatus;
    },
    fields: function fields(state) {
      return state.userWorkInfo.fields;
    }
  }),
  created: function created() {},

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), request.map([]), {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {
      return request.page('getUserWorkInfoTable', params);
    },
    onResetSearch: function onResetSearch() {
      this.resetSearch();
      this.onSearch({});
    },
    getStatusTagType: function getStatusTagType(status) {
      var statusMap = {
        0: 'warning', // 待审核 - 橙色
        1: 'success', // 审核通过 - 绿色
        2: 'danger' // 审核未通过 - 红色
      };
      return statusMap[status] || 'info';
    },
    downloadBatchRejectDemo: function downloadBatchRejectDemo() {
      this.$export('批量驳回职业信息Demo', [{
        'userid': '10000',
        'failed_reason': '证件照不清晰'
      }, {
        'userid': '10001',
        'failed_reason': '工种选择异常'
      }], {
        fileHeader: [{ key: 'userid', text: '用户ID' }, { key: 'failed_reason', text: '不通过原因' }]
      });
    },
    downloadBatchExpireDemo: function downloadBatchExpireDemo() {
      this.$export('批量过期职业信息Demo', [{
        'userid': '10000'
      }], {
        fileHeader: [{ key: 'userid', text: '用户ID' }]
      });
    },
    onClickExpireUploader: function onClickExpireUploader(e) {
      e.stopPropagation();
      this.$refs['batchExpireUploader'].$refs['upload-inner'].handleClick();
    },
    uploadBatchExpireFile: function uploadBatchExpireFile(file) {
      var _this = this;

      var isLt10M = file.file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!');
        return false;
      }

      var formData = new FormData();
      formData.append('file', file.file);

      request.common('batchExpireWorkInfoApi', formData).then(function (_ref) {
        var data = _ref.data;

        _this.$confirm('任务创建成功, 是否前往批量任务列表页面查看？', '提示', { type: 'success' }).then(function () {
          _this.$router.push({ path: '/users/batch/table' });
        });
      });
    },
    onClickUploader: function onClickUploader(e) {
      e.stopPropagation();
      this.$refs['batchRejectUploader'].$refs['upload-inner'].handleClick();
    },
    uploadBatchRejectFile: function uploadBatchRejectFile(file) {
      var _this2 = this;

      var isLt10M = file.file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!');
        return false;
      }

      var formData = new FormData();
      formData.append('file', file.file);

      request.common('batchRejectWorkInfoApi', formData).then(function (_ref2) {
        var data = _ref2.data;

        _this2.$confirm('任务创建成功, 是否前往批量任务列表页面查看？', '提示', { type: 'success' }).then(function () {
          _this2.$router.push({ path: '/users/batch/table' });
        });
      });
    },
    exportUserAuditWorkInfo: function exportUserAuditWorkInfo() {
      var _this3 = this;

      this.$confirm('是否按搜索条件导出用户职业信息数据？', '提示', { type: 'warning' }).then(function () {
        request.common('exportUserAuditWorkInfoApi', Object(__WEBPACK_IMPORTED_MODULE_6__core_mixins_table__["c" /* removeEmptyParams */])(_.cloneDeep(_this3.search))).then(function (_ref3) {
          var data = _ref3.data;

          _this3.$confirm('任务创建成功, 是否前往批量任务列表页面查看？', '提示', { type: 'success' }).then(function () {
            _this3.$router.push({ path: '/users/batch/table' });
          });
        });
      });
    },

    // 驳回，驳回原因必须填写
    onReject: function onReject(row) {
      var _this4 = this;

      this.$prompt('请填写驳回原因', '提示', {
        type: 'warning',
        inputPattern: /^\S+$/,
        inputErrorMessage: '请填写驳回原因'
      }).then(function () {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref5) {
          var value = _ref5.value;
          var auditForm;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  auditForm = {
                    id: row.id,
                    updated_at: row.updated_at,
                    is_rejected: 1,
                    failed_reason: value
                  };
                  _context.next = 3;
                  return request.common('auditUserWorkInfoData', auditForm);

                case 3:
                  _this4.$message.success('驳回成功');
                  _this4.onSearch();

                case 5:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this4);
        }));

        return function (_x) {
          return _ref4.apply(this, arguments);
        };
      }());
    },

    // 重置回待审核状态
    onResetToWaitAudit: function onResetToWaitAudit(row) {
      var _this5 = this;

      this.$confirm('是否将状态重置回待审核？', '提示', { type: 'warning' }).then(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = { id: row.id, updated_at: row.updated_at, is_rejected: 0, reset_to_wait_audit: 1 };
                _context2.next = 3;
                return request.common('auditUserWorkInfoData', params);

              case 3:
                _this5.$message.success('\u6570\u636E(' + row.id + ')\u91CD\u7F6E\u56DE\u5F85\u5BA1\u6838\u6210\u529F');
                _this5.onSearch();

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      })));
    }
  })
});

/***/ }),

/***/ 5763:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5764);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("b4c4d398", content, true, {});

/***/ }),

/***/ 5764:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".table-panel[data-v-d435890c]{margin-bottom:20px}.operation-buttons[data-v-d435890c]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:5px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.operation-buttons .el-button[data-v-d435890c]{margin:0;min-width:60px}.operation-buttons .margin.b5[data-v-d435890c]{margin-bottom:5px}.el-tag[data-v-d435890c]{font-weight:500}.el-dropdown-menu__item[data-v-d435890c]{padding:8px 16px;font-size:14px}.page-heading .el-breadcrumb[data-v-d435890c]{margin-top:8px;font-size:14px}.re-el-form__flex .el-form-item[data-v-d435890c]{margin-bottom:20px}.el-table .el-button--mini[data-v-d435890c]{padding:7px 12px;font-size:12px}.el-table .el-button--mini.el-button--primary[data-v-d435890c]{background:linear-gradient(135deg,#409eff,#66b1ff);border:none}.el-table .el-button--mini.el-button--primary[data-v-d435890c]:hover{background:linear-gradient(135deg,#66b1ff,#409eff);-webkit-transform:translateY(-1px);transform:translateY(-1px);-webkit-box-shadow:0 2px 8px rgba(64,158,255,.3);box-shadow:0 2px 8px rgba(64,158,255,.3)}.el-table .el-button--mini.el-button--success[data-v-d435890c]{background:linear-gradient(135deg,#67c23a,#85ce61);border:none}.el-table .el-button--mini.el-button--success[data-v-d435890c]:hover{background:linear-gradient(135deg,#85ce61,#67c23a);-webkit-transform:translateY(-1px);transform:translateY(-1px);-webkit-box-shadow:0 2px 8px rgba(103,194,58,.3);box-shadow:0 2px 8px rgba(103,194,58,.3)}.el-table .el-button--mini.el-button--danger[data-v-d435890c]{background:linear-gradient(135deg,#f56c6c,#f78989);border:none}.el-table .el-button--mini.el-button--danger[data-v-d435890c]:hover{background:linear-gradient(135deg,#f78989,#f56c6c);-webkit-transform:translateY(-1px);transform:translateY(-1px);-webkit-box-shadow:0 2px 8px hsla(0,87%,69%,.3);box-shadow:0 2px 8px hsla(0,87%,69%,.3)}.el-table .el-button--mini.el-button--warning[data-v-d435890c]{background:linear-gradient(135deg,#e6a23c,#ebb563);border:none}.el-table .el-button--mini.el-button--warning[data-v-d435890c]:hover{background:linear-gradient(135deg,#ebb563,#e6a23c);-webkit-transform:translateY(-1px);transform:translateY(-1px);-webkit-box-shadow:0 2px 8px rgba(230,162,60,.3);box-shadow:0 2px 8px rgba(230,162,60,.3)}.el-table .el-button--mini[data-v-d435890c]:active{-webkit-transform:translateY(0);transform:translateY(0)}.el-table[data-v-d435890c]{border:none!important}.el-table[data-v-d435890c]:before{height:0!important}.el-table .el-table__header-wrapper .el-table__header th[data-v-d435890c]{border-bottom:2px solid #e8e8e8!important;background-color:#fafafa!important;color:#333!important;font-weight:600!important}.el-table .el-table__body-wrapper .el-table__body tr[data-v-d435890c]{border-bottom:1px solid #f0f0f0!important}.el-table .el-table__body-wrapper .el-table__body tr[data-v-d435890c]:last-child{border-bottom:none!important}.el-table .el-table__body-wrapper .el-table__body tr[data-v-d435890c]:hover{background-color:#f8f9fa!important}.el-table td[data-v-d435890c],.el-table th[data-v-d435890c]{border:none!important}.pagination[data-v-d435890c]{margin-top:20px;text-align:center}.pagination .el-pagination[data-v-d435890c]{padding:20px 0;display:inline-block}.layout-panel[data-v-d435890c]{border-radius:8px;-webkit-box-shadow:0 2px 12px 0 rgba(0,0,0,.1);box-shadow:0 2px 12px 0 rgba(0,0,0,.1)}.layout-panel .el-card__header[data-v-d435890c]{background:linear-gradient(135deg,#f8f9fa,#e9ecef);border-bottom:1px solid #dee2e6;font-weight:600}", "", {"version":3,"sources":["/workspace/src/views/user-workinfo/pages/UserWorkInfoTable.vue"],"names":[],"mappings":"AACA,8BAA8B,kBAAkB,CAC/C,AACD,oCAAoC,oBAAoB,oBAAoB,aAAa,mBAAmB,eAAe,QAAQ,yBAAyB,sBAAsB,mBAAmB,uBAAuB,oBAAoB,0BAA0B,CACzQ,AACD,+CAA+C,SAAS,cAAc,CACrE,AACD,+CAA+C,iBAAiB,CAC/D,AAGD,yBAAyB,eAAe,CACvC,AACD,yCAAyC,iBAAiB,cAAc,CACvE,AACD,8CAA8C,eAAe,cAAc,CAC1E,AACD,iDAAiD,kBAAkB,CAClE,AACD,4CAA4C,iBAAiB,cAAc,CAC1E,AACD,+DAA+D,mDAAqD,WAAW,CAC9H,AACD,qEAAqE,mDAAqD,mCAAmC,2BAA2B,iDAAkD,wCAAyC,CAClR,AACD,+DAA+D,mDAAqD,WAAW,CAC9H,AACD,qEAAqE,mDAAqD,mCAAmC,2BAA2B,iDAAkD,wCAAyC,CAClR,AACD,8DAA8D,mDAAqD,WAAW,CAC7H,AACD,oEAAoE,mDAAqD,mCAAmC,2BAA2B,gDAAmD,uCAA0C,CACnR,AACD,+DAA+D,mDAAqD,WAAW,CAC9H,AACD,qEAAqE,mDAAqD,mCAAmC,2BAA2B,iDAAkD,wCAAyC,CAClR,AACD,mDAAmD,gCAAgC,uBAAuB,CACzG,AACD,2BAA2B,qBAAsB,CAChD,AACD,kCAAmC,kBAAmB,CACrD,AACD,0EAA0E,0CAA2C,mCAAoC,qBAAsB,yBAA0B,CACxM,AACD,sEAAsE,yCAA0C,CAC/G,AACD,iFAAiF,4BAA6B,CAC7G,AACD,4EAA4E,kCAAmC,CAC9G,AAGD,4DAA8B,qBAAsB,CACnD,AACD,6BAA6B,gBAAgB,iBAAiB,CAC7D,AACD,4CAA4C,eAAe,oBAAoB,CAC9E,AACD,+BAA+B,kBAAkB,+CAAgD,sCAAuC,CACvI,AACD,gDAAgD,mDAAqD,gCAAgC,eAAe,CACnJ","file":"UserWorkInfoTable.vue","sourcesContent":["\n.table-panel[data-v-d435890c]{margin-bottom:20px\n}\n.operation-buttons[data-v-d435890c]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:5px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start\n}\n.operation-buttons .el-button[data-v-d435890c]{margin:0;min-width:60px\n}\n.operation-buttons .margin.b5[data-v-d435890c]{margin-bottom:5px\n}\n.el-tag[data-v-d435890c]{font-weight:500\n}\n.el-tag[data-v-d435890c]{font-weight:500\n}\n.el-dropdown-menu__item[data-v-d435890c]{padding:8px 16px;font-size:14px\n}\n.page-heading .el-breadcrumb[data-v-d435890c]{margin-top:8px;font-size:14px\n}\n.re-el-form__flex .el-form-item[data-v-d435890c]{margin-bottom:20px\n}\n.el-table .el-button--mini[data-v-d435890c]{padding:7px 12px;font-size:12px\n}\n.el-table .el-button--mini.el-button--primary[data-v-d435890c]{background:linear-gradient(135deg, #409EFF, #66b1ff);border:none\n}\n.el-table .el-button--mini.el-button--primary[data-v-d435890c]:hover{background:linear-gradient(135deg, #66b1ff, #409EFF);-webkit-transform:translateY(-1px);transform:translateY(-1px);-webkit-box-shadow:0 2px 8px rgba(64,158,255,0.3);box-shadow:0 2px 8px rgba(64,158,255,0.3)\n}\n.el-table .el-button--mini.el-button--success[data-v-d435890c]{background:linear-gradient(135deg, #67C23A, #85ce61);border:none\n}\n.el-table .el-button--mini.el-button--success[data-v-d435890c]:hover{background:linear-gradient(135deg, #85ce61, #67C23A);-webkit-transform:translateY(-1px);transform:translateY(-1px);-webkit-box-shadow:0 2px 8px rgba(103,194,58,0.3);box-shadow:0 2px 8px rgba(103,194,58,0.3)\n}\n.el-table .el-button--mini.el-button--danger[data-v-d435890c]{background:linear-gradient(135deg, #F56C6C, #f78989);border:none\n}\n.el-table .el-button--mini.el-button--danger[data-v-d435890c]:hover{background:linear-gradient(135deg, #f78989, #F56C6C);-webkit-transform:translateY(-1px);transform:translateY(-1px);-webkit-box-shadow:0 2px 8px rgba(245,108,108,0.3);box-shadow:0 2px 8px rgba(245,108,108,0.3)\n}\n.el-table .el-button--mini.el-button--warning[data-v-d435890c]{background:linear-gradient(135deg, #E6A23C, #ebb563);border:none\n}\n.el-table .el-button--mini.el-button--warning[data-v-d435890c]:hover{background:linear-gradient(135deg, #ebb563, #E6A23C);-webkit-transform:translateY(-1px);transform:translateY(-1px);-webkit-box-shadow:0 2px 8px rgba(230,162,60,0.3);box-shadow:0 2px 8px rgba(230,162,60,0.3)\n}\n.el-table .el-button--mini[data-v-d435890c]:active{-webkit-transform:translateY(0);transform:translateY(0)\n}\n.el-table[data-v-d435890c]{border:none !important\n}\n.el-table[data-v-d435890c]::before{height:0 !important\n}\n.el-table .el-table__header-wrapper .el-table__header th[data-v-d435890c]{border-bottom:2px solid #e8e8e8 !important;background-color:#fafafa !important;color:#333 !important;font-weight:600 !important\n}\n.el-table .el-table__body-wrapper .el-table__body tr[data-v-d435890c]{border-bottom:1px solid #f0f0f0 !important\n}\n.el-table .el-table__body-wrapper .el-table__body tr[data-v-d435890c]:last-child{border-bottom:none !important\n}\n.el-table .el-table__body-wrapper .el-table__body tr[data-v-d435890c]:hover{background-color:#f8f9fa !important\n}\n.el-table td[data-v-d435890c]{border:none !important\n}\n.el-table th[data-v-d435890c]{border:none !important\n}\n.pagination[data-v-d435890c]{margin-top:20px;text-align:center\n}\n.pagination .el-pagination[data-v-d435890c]{padding:20px 0;display:inline-block\n}\n.layout-panel[data-v-d435890c]{border-radius:8px;-webkit-box-shadow:0 2px 12px 0 rgba(0,0,0,0.1);box-shadow:0 2px 12px 0 rgba(0,0,0,0.1)\n}\n.layout-panel .el-card__header[data-v-d435890c]{background:linear-gradient(135deg, #f8f9fa, #e9ecef);border-bottom:1px solid #dee2e6;font-weight:600\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5765:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return searchRules; });
/* unused harmony export formRules */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入正确的user-workinfoID', 'integer', 'blur', false), { min: 1 })]
};

var formRules = {
  name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入user-workinfo名称', 'string')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入至少2个字符', 'string'), { min: 2 })]
};

/***/ }),

/***/ 5766:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v("\n      "+_vm._s(_vm.$route.meta.title)+"\n    ")]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("用户职业信息审核列表")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"collapse":false}},[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"rules":_vm.searchRules,"label-width":"96px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"ID","prop":"id"}},[_c('el-input',{staticClass:"width-max",attrs:{"placeholder":"请输入ID","clearable":""},model:{value:(_vm.search.id),callback:function ($$v) {_vm.$set(_vm.search, "id", $$v)},expression:"search.id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"用户ID","prop":"userid"}},[_c('el-input',{staticClass:"width-max",attrs:{"placeholder":"请输入用户ID","clearable":""},model:{value:(_vm.search.userid),callback:function ($$v) {_vm.$set(_vm.search, "userid", $$v)},expression:"search.userid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"用户手机号","prop":"cellphone"}},[_c('el-input',{staticClass:"width-max",attrs:{"placeholder":"请输入用户手机号","clearable":""},model:{value:(_vm.search.cellphone),callback:function ($$v) {_vm.$set(_vm.search, "cellphone", $$v)},expression:"search.cellphone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"状态","prop":"status"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择状态","clearable":""},model:{value:(_vm.search.status),callback:function ($$v) {_vm.$set(_vm.search, "status", $$v)},expression:"search.status"}},_vm._l((_vm.workInfoStatus),function(label,value){return _c('el-option',{key:value,attrs:{"label":label,"value":value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"更新时间","prop":"updated_at"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","default-time":['00:00:00', '23:59:59'],"align":"right"},model:{value:(_vm.search.updated_at),callback:function ($$v) {_vm.$set(_vm.search, "updated_at", $$v)},expression:"search.updated_at"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索")]),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-refresh-left"},on:{"click":function($event){return _vm.onResetSearch()}}},[_vm._v("重置")]),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-download"},on:{"click":function($event){return _vm.exportUserAuditWorkInfo()}}},[_vm._v("按搜索结果导出\n        ")])],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('div',{staticClass:"margin b15"},[_c('el-dropdown',{attrs:{"split-button":"","type":"primary","size":"small","icon":"el-icon-remove-outline","trigger":"click"},on:{"click":_vm.onClickUploader}},[_vm._v("\n        批量驳回\n        "),_c('el-upload',{ref:"batchRejectUploader",staticStyle:{"display":"none"},attrs:{"action":"","accept":".xlsx","http-request":_vm.uploadBatchRejectFile,"show-file-list":false}}),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"icon":"el-icon-download"},nativeOn:{"click":function($event){return _vm.downloadBatchRejectDemo($event)}}},[_vm._v("下载Demo文件")])],1)],1),_vm._v(" "),_c('el-dropdown',{attrs:{"split-button":"","type":"primary","size":"small","icon":"el-icon-remove-outline","trigger":"click"},on:{"click":_vm.onClickExpireUploader}},[_vm._v("\n        批量过期\n        "),_c('el-upload',{ref:"batchExpireUploader",staticStyle:{"display":"none"},attrs:{"action":"","accept":".xlsx","http-request":_vm.uploadBatchExpireFile,"show-file-list":false}}),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"icon":"el-icon-download"},nativeOn:{"click":function($event){return _vm.downloadBatchExpireDemo($event)}}},[_vm._v("下载Demo文件")])],1)],1)],1),_vm._v(" "),_c('el-table',{ref:"multipleTable",attrs:{"data":_vm.table,"stripe":"","highlight-current-row":""}},[_vm._l((_vm.fields),function(attr){return [(attr.prop === 'status_cn')?_c('el-table-column',_vm._b({key:((attr.prop) + "-tag"),scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":_vm.getStatusTagType(scope.row.status)}},[_vm._v("\n              "+_vm._s(scope.row.status_cn)+"\n            ")])]}}],null,true)},'el-table-column',attr,false)):(attr.prop === 'workinfo_passed_times')?_c('el-table-column',_vm._b({key:attr.prop,scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.workinfo_passed_times && scope.row.workinfo_passed_times > 0 ? scope.row.workinfo_passed_times : '')+"\n          ")]}}],null,true)},'el-table-column',attr,false)):_c('el-table-column',_vm._b({key:attr.prop},'el-table-column',attr,false))]}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"220px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"operation-buttons"},[_c('router-link',{attrs:{"to":("/user-workinfo/detail/" + (scope.row.id))}},[_c('el-button',{staticClass:"margin b5",attrs:{"type":"primary","size":"mini","icon":"el-icon-view"}},[_vm._v("查看\n              ")])],1),_vm._v(" "),(scope.row.status + '' === '0')?_c('router-link',{attrs:{"to":("/user-workinfo/audit/" + (scope.row.id))}},[_c('el-button',{staticClass:"margin b5",attrs:{"type":"success","size":"mini","icon":"el-icon-check"}},[_vm._v("审核\n              ")])],1):_vm._e(),_vm._v(" "),(scope.row.status + '' === '1')?_c('el-button',{staticClass:"margin b5",attrs:{"type":"danger","size":"mini","icon":"el-icon-close"},on:{"click":function($event){return _vm.onReject(scope.row)}}},[_vm._v("驳回\n            ")]):_vm._e(),_vm._v(" "),(scope.row.status + '' === '2')?_c('el-button',{staticClass:"margin b5",attrs:{"type":"warning","size":"mini","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onResetToWaitAudit(scope.row)}}},[_vm._v("重置待审核\n            ")]):_vm._e()],1)]}}])})],2),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/user-work-info-table.a978d08270498df258a6.js